import { HStack, Stack, Text, Tooltip, VStack } from "@chakra-ui/react";
import FacebookIdentity from "./FacebookIdentity";
import InstagramIdentity from "./InstagramIdentity";
import { PublisherPlatforms } from "common/interfaces/KYDMarketing";

interface CreativeIdentitySectionProps {
  facebookPageId?: string;
  instagramActorId?: string;
  eventLink?: string;
  pages: any[];
  instagramAccounts: any[];
}

const CreativeIdentitySection = ({
  facebookPageId,
  instagramActorId,
  eventLink,
  pages,
  instagramAccounts,
}: CreativeIdentitySectionProps) => {
  return (
    <Stack
      justifyContent="space-between"
      gap={4}
      flexGrow={1}
      w="full"
      alignItems="flex-start"
      fontWeight="medium"
      direction={["column", "row"]}
    >
      <VStack flexGrow={1} alignItems="flex-start" w="full">
        <Text color="gray.500" fontWeight="medium">
          Identity
        </Text>
        <FacebookIdentity id={facebookPageId} pages={pages} />
        <InstagramIdentity
          id={instagramActorId}
          instagramAccounts={instagramAccounts}
        />
      </VStack>
      <VStack flexGrow={1} alignItems="flex-start" w="full" maxW="50%">
        <Text color="gray.500" fontWeight="medium">
          Event link
        </Text>
        <Tooltip label={eventLink}>
          <Text
            fontSize="sm"
            textOverflow="ellipsis"
            flexShrink={0}
            w="full"
            noOfLines={2}
          >
            {eventLink}
          </Text>
        </Tooltip>
      </VStack>
    </Stack>
  );
};

export default CreativeIdentitySection;
